import React, { useContext, useState } from 'react'
import { Form, Input, Button, Typography, message, Card, Space, Spin } from 'antd'
import { EyeInvisibleOutlined, EyeTwoTone, MailOutlined, LockOutlined, UserOutlined } from '@ant-design/icons'
import { login, register } from '../services/request'
import { useHistory } from 'react-router-dom'
import Header from '../components/Header'
import AppContext from '../context/Context'

const { Title, Text } = Typography

export default function LoginPage () {
  const [isLogin, setIsLogin] = useState(true)
  const [form] = Form.useForm()
  const history = useHistory()
  const host = process.env.REACT_APP_API_URL
  const { setLoading, loading } = useContext(AppContext)

  const handleLogin = async (username, email, password) => {
    try {
      setLoading(true)
      if (isLogin) {
        await login(email, password, host)
        const userData = JSON.parse(localStorage.getItem('user'))
        message.success('Login realizado com sucesso!')
        history.push(userData?.role === 'admin' ? '/products' : '/')
      } else {
        await register(username, email, password, host)
        message.success('Cadastro realizado com sucesso!')
        history.push('/')
      }
    } catch (error) {
      message.error('Ocorreu um erro. Verifique os dados e tente novamente.')
    } finally {
      setLoading(false)
    }
  }

  const onFinish = (values) => {
    const { username, email, password } = values
    handleLogin(username, email, password)
    form.resetFields()
  }

  return (
    <>
      <Header />
      <Spin
        spinning={loading}
        tip="Carregando..."
        size="large"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(255,255,255,0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'center', padding: '40px 16px' }}>
          <Card style={{ maxWidth: 400, width: '100%', textAlign: 'center' }} bordered>
            <Title level={3} style={{ marginBottom: 24 }}>
              {isLogin ? 'Login' : 'Cadastro'}
            </Title>

            <Form form={form} layout="vertical" onFinish={onFinish}>
              {!isLogin && (
                <Form.Item
                  label="Nome"
                  name="username"
                  rules={[{ required: true, message: 'Informe seu nome!' }]}
                >
                  <Input prefix={<UserOutlined />} placeholder="Seu nome" />
                </Form.Item>
              )}

              <Form.Item
                label="E-mail"
                name="email"
                rules={[{ required: true, message: 'Informe seu e-mail!' }]}
              >
                <Input prefix={<MailOutlined />} type="email" placeholder="Digite seu e-mail" />
              </Form.Item>

              <Form.Item
                label="Senha"
                name="password"
                rules={[{ required: true, message: 'Informe sua senha!' }]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Digite sua senha"
                  iconRender={(visible) =>
                    (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  {isLogin ? 'Entrar' : 'Cadastrar'}
                </Button>
              </Form.Item>
            </Form>

            <Space direction="vertical" style={{ marginTop: 16 }}>
              <Text>{isLogin ? 'Não tem uma conta?' : 'Já tem uma conta?'}</Text>
              <Button type="link" onClick={() => setIsLogin(!isLogin)}>
                {isLogin ? 'Cadastre-se' : 'Faça login'}
              </Button>
            </Space>
          </Card>
        </div>
      </Spin>
    </>
  )
}
